// Panduan penggunaan (ditulis ulang 2026-10-12): alur lama berbasis cookie & setup email oleh admin sudah
// tidak berlaku. Isi mengikuti fitur aktif klien — fitur yang belum dibuka tetap ditampilkan dengan label
// "Hubungi admin untuk mengaktifkan fitur ini" (UGC dkk. default tertutup di luar paket). Angka paket
// sengaja tidak ditulis di sini; sumbernya menu Langganan.
import React, { useState } from 'react';
import { colors, radius } from '../theme';

export default function Panduan({ fiturOn = () => true, ugcOn = false, onNav }) {
  const [aktif, setAktif] = useState('mulai');
  const ugcAda = ugcOn && fiturOn('ugc');
  const platform = ['YouTube', fiturOn('tiktok') && 'TikTok', fiturOn('instagram') && 'Instagram'].filter(Boolean)
    .join(', ').replace(/, ([^,]*)$/, ' & $1');

  const bagian = {
    mulai: {
      label: 'Cara mulai', icon: 'ti-rocket',
      intro: 'Empat langkah dari akun baru sampai video pertama terunggah.',
      items: [
        { step: 1, icon: 'ti-plug-connected', title: `Hubungkan akun ${platform}`, nav: 'channels', cta: 'Hubungkan channel',
          desc: 'Buka menu Hubungkan channel, klik tombol platform yang diinginkan, lalu login dengan akun pemilik channel dan izinkan akses.',
          points: ['Tidak perlu cookie, ekstensi browser, atau mendaftarkan email lebih dulu.', 'Satu klik hubungkan = satu akun. Ulangi untuk channel berikutnya.', 'Jumlah channel maksimal mengikuti paketmu (lihat menu Langganan).'] },
        { step: 2, icon: 'ti-badge', title: 'Pasang logo watermark (opsional)',
          desc: 'Klik nama/avatar kamu di sidebar → Profil → Logo Watermark.',
          points: ['Pakai PNG transparan supaya logo tampil tanpa kotak putih.', 'Watermark bisa dinyalakan/dimatikan per video di form Buat konten.'] },
        { step: 3, icon: 'ti-upload', title: 'Buat konten pertama', nav: 'jobs', cta: 'Buat konten',
          desc: fiturOn('url_source')
            ? 'Di menu Buat konten, tempel link video atau unggah file dari perangkat, isi judul, pilih channel tujuan, lalu kirim.'
            : 'Di menu Buat konten, unggah file video dari perangkat, isi judul, pilih channel tujuan, lalu kirim.',
          points: ['Sistem memproses video lalu mengunggahnya ke setiap channel yang dipilih.', 'Detail opsi ada di tab "Membuat konten".'] },
        { step: 4, icon: 'ti-list-details', title: 'Pantau hasilnya', nav: 'laporan', cta: 'Riwayat job',
          desc: 'Status tiap video per channel tampil di Riwayat job.',
          points: fiturOn('analytics') ? ['Perkembangan views per channel ada di menu Analytics.'] : ['Analytics views per channel adalah fitur tambahan.'] },
      ],
    },
    konten: {
      label: 'Membuat konten', icon: 'ti-movie',
      intro: 'Semua cara membuat dan mengirim konten dari dashboard.',
      items: [
        { icon: 'ti-device-mobile', title: 'Shorts dari link atau file', nav: 'jobs', cta: 'Buat konten',
          desc: 'Video diubah ke format vertikal 9:16, dipotong sesuai durasi pilihan, lalu diunggah sebagai Shorts.',
          points: [
            fiturOn('url_source') ? 'Sumber: tempel link video, atau unggah file dari perangkat.' : 'Sumber: unggah file dari perangkat. (Sumber dari link: hubungi admin untuk mengaktifkan.)',
            'Durasi klip: acak, 30, 45, atau 57 detik (maks 57 agar aman dari blokir YouTube untuk lagu ber-hak cipta) — titik mulai bisa acak atau ditentukan.',
            'Opsi tambahan: subtitle otomatis (AI), logo watermark, dan thumbnail Shorts.',
            'Pilih platform tujuan: YouTube' + (fiturOn('tiktok') ? ', TikTok' : '') + (fiturOn('instagram') ? ', Instagram' : '') + '.',
          ] },
        { icon: 'ti-movie', title: 'Kompilasi video panjang (UGC)', nav: 'vp', cta: 'Video panjang', off: !ugcAda,
          desc: 'Gabungkan beberapa lagu menjadi satu video kompilasi panjang, lengkap dengan visual, judul tiap lagu, dan chapter.',
          points: ['Susun lagu di editor, atur tampilan, lalu render.', 'Sudah punya video kompilasi jadi? Pakai "Upload Video Jadi" — tanpa render.', 'Setelah siap: isi SEO, pilih channel, atur jadwal, lalu Setujui.'] },
        { icon: 'ti-clock-play', title: 'Jadwal kirim',
          desc: 'Atur kapan video diunggah ke tiap channel, supaya tidak serentak.',
          points: ['Langsung — semua channel segera setelah video siap.', 'Bertahap — jeda tetap antar channel.', 'Acak — waktu acak dalam rentang yang kamu tentukan.', 'Bisa juga dimulai N menit setelah render selesai.'] },
        { icon: 'ti-rocket', title: 'Campaign (grup channel)', nav: 'campaigns', cta: 'Campaign', off: !fiturOn('campaigns'),
          desc: 'Simpan sekumpulan channel sebagai Campaign, lalu pilih dengan sekali klik di form Shorts maupun UGC.',
          points: ['Ringkasan views & upload per Campaign, dipisah Shorts dan UGC.'] },
        { icon: 'ti-photo-ai', title: 'Thumbnail', nav: 'thumbnails', cta: 'Thumbnail AI',
          desc: 'Buat thumbnail Shorts langsung di form, atau unggah gambar sendiri.',
          points: [fiturOn('thumbnail_ai') ? 'Menu Thumbnail AI membuat thumbnail dengan AI.' : 'Thumbnail AI: hubungi admin untuk mengaktifkan.'] },
      ],
    },
    akun: {
      label: 'Akun & channel', icon: 'ti-plug-connected',
      intro: 'Menghubungkan, menambah, dan memperbaiki koneksi akun.',
      items: [
        { icon: 'ti-brand-youtube', title: 'YouTube', nav: 'channels', cta: 'Hubungkan channel',
          desc: 'Klik Hubungkan Channel YouTube lalu login dengan akun Google pemilik channel.',
          points: ['Akun Google dengan banyak channel (brand account): pilih channel yang dituju di layar Google.', 'Kotak pencarian di menu Hubungkan channel membantu saat channel sudah banyak.'] },
        { icon: 'ti-brand-tiktok', title: 'TikTok', off: !fiturOn('tiktok'),
          desc: 'Klik Hubungkan TikTok lalu login dan izinkan akses.',
          points: ['Menambah akun TikTok kedua dst.: TikTok otomatis memakai akun yang sedang login di browser. Gunakan jendela incognito, atau logout dari tiktok.com dulu, lalu klik Hubungkan TikTok.', 'Agar opsi "Publik" muncul saat posting, akun TikTok harus berstatus publik (bukan akun privat).'] },
        { icon: 'ti-brand-instagram', title: 'Instagram', off: !fiturOn('instagram'),
          desc: 'Klik Hubungkan Instagram lalu ikuti langkah login.',
          points: ['Gunakan akun Instagram Profesional (Bisnis atau Kreator).'] },
        { icon: 'ti-alert-triangle', title: 'Channel "Perlu dihubungkan ulang"',
          desc: 'Izin akses ke channel kedaluwarsa atau dicabut. Unggahan ke channel itu berhenti sampai dihubungkan ulang.',
          points: ['Buka Hubungkan channel → klik "Hubungkan ulang" pada channel tersebut → login dengan akun yang sama.', 'Riwayat terhubung/terputus tiap akun tercatat di halaman yang sama.'] },
      ],
    },
    status: {
      label: 'Status & kendala', icon: 'ti-activity',
      intro: 'Arti status job dan apa yang perlu (dan tidak perlu) dilakukan.',
      items: [
        { icon: 'ti-hourglass', title: 'Pending / processing',
          desc: 'Job sedang antre atau diproses di server.',
          points: ['Browser boleh ditutup — proses berjalan di server.', 'Jangan kirim ulang video yang sama; nanti terunggah dua kali.'] },
        { icon: 'ti-refresh', title: 'Dijadwalkan ulang otomatis',
          desc: 'Kalau kuota YouTube harian penuh atau ada gangguan sesaat, unggahan dijadwalkan ulang otomatis.',
          points: ['Tidak perlu kirim ulang — cek lagi di Riwayat job nanti.'] },
        { icon: 'ti-circle-x', title: 'Gagal',
          desc: 'Unggahan ke channel tertentu tidak berhasil setelah beberapa kali dicoba.',
          points: ['Cek apakah channel bertanda "Perlu dihubungkan ulang".', 'Untuk sumber link: pastikan video bisa diakses publik (tidak privat/dihapus).', 'Masih gagal? Hubungi support dengan menyebut judul job.'] },
        { icon: 'ti-gauge', title: 'Batas upload harian',
          desc: 'Jumlah upload per hari mengikuti paket dan kuota YouTube.',
          points: ['Kuota direset sekitar pukul 14.00–15.00 WIB (mengikuti reset Google).', 'Detail paketmu ada di menu Langganan.'] },
      ],
    },
    faq: {
      label: 'FAQ', icon: 'ti-help-circle',
      intro: 'Pertanyaan yang sering muncul.',
      items: [
        { icon: 'ti-lock-open', title: 'Kenapa ada fitur yang terkunci?',
          desc: 'Sebagian fitur (misalnya Video panjang) tidak termasuk paket standar dan dibuka per akun.',
          points: ['Hubungi admin untuk mengaktifkan fitur yang kamu butuhkan.'] },
        { icon: 'ti-shield-check', title: 'Apakah channel saya aman?',
          desc: 'Akses diberikan lewat login resmi Google/TikTok/Instagram — kami tidak pernah meminta password.',
          points: ['Akses bisa dicabut kapan saja dengan menghapus channel di dashboard atau dari pengaturan akun Google/TikTok.', 'Pastikan konten yang diunggah milikmu atau sudah berizin; pelanggaran hak cipta menjadi tanggung jawab pemilik channel.'] },
        { icon: 'ti-calendar-due', title: 'Apakah langganan diperpanjang otomatis?',
          desc: 'Tidak. Perpanjang sebelum masa aktif berakhir lewat menu Langganan.',
          points: ['Job tidak diproses saat langganan sudah berakhir.'] },
        { icon: 'ti-arrows-exchange', title: 'Bisa ganti paket?',
          desc: 'Bisa kapan saja — hubungi admin untuk upgrade atau downgrade.' },
      ],
    },
  };

  const menu = Object.entries(bagian);
  const cur = bagian[aktif];

  return (
    <div style={S.wrap}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={S.h1}><i className="ti ti-book" style={{ color: colors.accent }}></i>Panduan</h1>
        <p style={S.lead}>Cara memakai Eighteen Media, dari menghubungkan channel sampai memantau hasil.</p>
      </div>

      <div style={S.tabs} role="tablist">
        {menu.map(([id, b]) => (
          <button key={id} role="tab" aria-selected={aktif === id} onClick={() => setAktif(id)} style={{ ...S.tab, ...(aktif === id ? S.tabOn : {}) }}>
            <i className={`ti ${b.icon}`} style={{ fontSize: 15 }}></i>{b.label}
          </button>
        ))}
      </div>

      <p style={S.intro}>{cur.intro}</p>

      <div style={S.grid}>
        {cur.items.map((it, i) => {
          const off = it.off === true;
          return (
            <div key={aktif + i} style={{ ...S.card, ...(off ? S.cardOff : {}) }}>
              <div style={S.cardHead}>
                {it.step
                  ? <div style={S.num}>{it.step}</div>
                  : <div style={{ ...S.ico, ...(off ? { color: colors.textMuted, background: colors.bgCardMuted } : {}) }}><i className={`ti ${it.icon}`}></i></div>}
                <h3 style={S.cardTitle}>{it.title}</h3>
              </div>
              {off && (
                <div style={S.lock}><i className="ti ti-lock" style={{ fontSize: 14 }}></i>Hubungi admin untuk mengaktifkan fitur ini</div>
              )}
              <p style={S.desc}>{it.desc}</p>
              {it.points && it.points.length > 0 && (
                <ul style={S.ul}>
                  {it.points.map((p, j) => <li key={j} style={S.li}><span style={S.dot} />{p}</li>)}
                </ul>
              )}
              {it.nav && !off && onNav && (
                <button onClick={() => onNav(it.nav)} style={S.go}>Buka {it.cta} <i className="ti ti-arrow-right" style={{ fontSize: 13 }}></i></button>
              )}
            </div>
          );
        })}
      </div>

      <div style={S.help}>
        <div>
          <div style={{ fontWeight: 600, color: colors.textPrimary, marginBottom: 2 }}>Masih bingung atau butuh fitur tambahan?</div>
          <div style={{ color: colors.textSecondary }}>Tim kami siap membantu.</div>
        </div>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', alignItems: 'center' }}>
          <a href="https://t.me/FZL420" target="_blank" rel="noreferrer" style={S.helpLink}><i className="ti ti-brand-telegram"></i>@FZL420</a>
          <a href="mailto:support@eighteen-media.id" style={S.helpLink}><i className="ti ti-mail"></i>support@eighteen-media.id</a>
        </div>
      </div>
    </div>
  );
}

const S = {
  wrap: { padding: '0 0 40px', maxWidth: 1000 },
  h1: { fontSize: 22, fontWeight: 700, color: colors.textPrimary, margin: 0, display: 'flex', alignItems: 'center', gap: 8 },
  lead: { fontSize: 13.5, color: colors.textSecondary, margin: '6px 0 0' },
  tabs: { display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14, borderBottom: `1px solid ${colors.border}`, paddingBottom: 10 },
  tab: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 999, border: `1px solid ${colors.border}`, background: colors.bgCard, color: colors.textSecondary, fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  tabOn: { background: colors.accentMuted, borderColor: colors.accent, color: colors.accentText, fontWeight: 600 },
  intro: { fontSize: 13, color: colors.textSecondary, margin: '0 0 14px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 300px), 1fr))', gap: 12 },
  card: { background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 18, display: 'flex', flexDirection: 'column' },
  cardOff: { background: colors.bgCardMuted },
  cardHead: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 },
  num: { width: 28, height: 28, borderRadius: '50%', background: colors.accent, color: '#fff', fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  ico: { width: 30, height: 30, borderRadius: 8, background: colors.accentMuted, color: colors.accent, fontSize: 17, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  cardTitle: { fontSize: 14.5, fontWeight: 600, color: colors.textPrimary, margin: 0, lineHeight: 1.35 },
  lock: { display: 'inline-flex', alignSelf: 'flex-start', alignItems: 'center', gap: 5, fontSize: 11.5, fontWeight: 600, color: colors.goldText, background: colors.goldMuted, border: `1px solid ${colors.gold}`, borderRadius: 8, padding: '4px 10px', marginBottom: 8, lineHeight: 1.35 },
  desc: { fontSize: 13, color: colors.textSecondary, lineHeight: 1.6, margin: '0 0 8px' },
  ul: { listStyle: 'none', padding: 0, margin: '0 0 4px' },
  li: { display: 'flex', gap: 8, fontSize: 13, color: colors.textPrimary, lineHeight: 1.55, padding: '3px 0' },
  dot: { width: 5, height: 5, borderRadius: '50%', background: colors.borderStrong, marginTop: 8, flexShrink: 0 },
  go: { marginTop: 'auto', alignSelf: 'flex-start', padding: '6px 12px', borderRadius: 999, border: `1px solid ${colors.border}`, background: colors.bgCard, color: colors.accentText, fontSize: 12.5, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 5 },
  help: { marginTop: 20, padding: '16px 18px', borderRadius: radius.lg, background: colors.bgCardMuted, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 14, flexWrap: 'wrap', fontSize: 13 },
  helpLink: { color: colors.accentText, fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 5 },
};
